"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNoneOption = exports.getMeOption = exports.getAllOption = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _once = _interopRequireDefault(require("transmute/once"));

var _OwnerIdValues = require("./OwnerIdValues");

var _PropertyOptionRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyOptionRecord"));

var getAllOption = (0, _once.default)(function () {
  return (0, _PropertyOptionRecord.default)({
    label: _I18n.default.text('customerDataObjects.OwnerIdSelect.all'),
    value: _OwnerIdValues.ALL_OWNER_VALUE
  });
});
exports.getAllOption = getAllOption;
var getMeOption = (0, _once.default)(function () {
  return (0, _PropertyOptionRecord.default)({
    label: _I18n.default.text('customerDataObjects.OwnerIdSelect.me'),
    value: _OwnerIdValues.ME_OWNER_VALUE,
    description: _I18n.default.text('customerDataObjects.OwnerIdSelect.meDescription')
  });
});
exports.getMeOption = getMeOption;
var getNoneOption = (0, _once.default)(function () {
  return (0, _PropertyOptionRecord.default)({
    label: _I18n.default.text('customerDataObjects.OwnerIdSelect.none'),
    value: _OwnerIdValues.NONE_OWNER_VALUE
  });
});
exports.getNoneOption = getNoneOption;